import { render, staticRenderFns } from "./ItemListing.vue?vue&type=template&id=45275ae1&scoped=true&"
import script from "./ItemListing.vue?vue&type=script&lang=js&"
export * from "./ItemListing.vue?vue&type=script&lang=js&"
import style0 from "./ItemListing.vue?vue&type=style&index=0&id=45275ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45275ae1",
  null
  
)

export default component.exports